// Re-points the shared meeting-delete modal at the right meeting when its
// per-row trash button is clicked. Lives at the index page scope so any
// trash button can reach the same modal without rendering N copies.
//
// Connects via: data-controller="meetings--delete"
// Targets: form, title
// Action:  data-action="click->meetings--delete#prompt"
// Trigger button data attributes:
//   data-meeting-url    (required) - DELETE url for the meeting
//   data-meeting-title  (optional) - shown in the modal heading

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'title']

  prompt(event) {
    const button = event.currentTarget
    const url = button.dataset.meetingUrl
    const title = button.dataset.meetingTitle || 'this meeting'

    this.resetForm()
    if (this.hasFormTarget && url) {
      this.formTarget.action = url
    }
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = `Delete "${title}"?`
    }
  }

  resetForm() {
    if (this.hasFormTarget) {
      this.formTarget.reset()
    }
  }
}
